/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoNavbar implements angular.IDirective {
        restrict = "E";
        require = "ngModel";
        scope = {
            contexts: "=ngModel"
        };
        taskBarColor = "#5E35B1 !important";
        constructor(
            private window: ng.IWindowService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private dataService: Meevo.Components.Common.ICommonDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private printService: Meevo.Components.Common.IPrintService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private rootScope: ng.IRootScopeService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private menuService: Meevo.MenuService,
            private alertsLogService: Meevo.Plugins.AlertsLog.IAlertsLogService,
            private $translate: angular.translate.ITranslateService,
            protected context?: Meevo.Plugins.BusinessInfo.BusinessInfoContext) {

        }

        templateUrl = "app/components/controls/navbarHtml.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.displayDropdown = false;
            scope.offClickBound = false;
            scope.displayUserMenu = false;
            scope.identityService = this.identityService;

            Object.defineProperty(scope, 'alertsCount', {
                get: () => this.alertsLogService.alertsCount
            });

            this.printService.getPrinterList().then((printerList) => {
                scope.printerList = printerList;
                this.printService.getSelectedPrinter().then(printer => scope.receiptPrinter = printer);
            });

            let uri = `/${this.appSettings.API_ROOT}/Settings/HelpDeskTicket`;
            this.dataService.customMethodData(uri, "get", {}).then((data) => {
                scope.showLiveChatMenu = data.data.liveChatSupport;
                scope.showSalesForceHelpDeskTicket = data.data.salesforceSupport;
            });

            scope.receiptPrinterChanged = () => {
                this.printService.setSelectedPrinter(scope.receiptPrinter);
                let isSystemPrinterGuid = (new Guid(scope.receiptPrinter.id.toString())).equals(Guid.empty);
                let request = {
                    lastUsedPrinterId: isSystemPrinterGuid ? null : scope.receiptPrinter.id.toString()
                    , clearLastUsedPrinter: isSystemPrinterGuid
                };
                this.dataService.customMethodData("api/session/DrawerPreferences", "PATCH", request);
            }

            scope.$on(Components.Common.Messages.PRINTER_SELECTED, (event, args, params) => {
                scope.receiptPrinter = _.findWhere(scope.printerList, { id: params.id });
            });

            /**
            *  Will probably change
            *  (8 * context.title.length + 45
            *  8 Pixels per character + 45 for the close button, defaults to.146 if result is smaller than that
            *
            *  8 * contextItems[i].title.length + 51 + i = temp + 50
            *  Equation for checking if there is enough space - extra 6+i pixels for each tab to make up for margins and any other inconsistencies
            **/
            // define dom elements

            var dropdownBtn1 = angular.element('.drop-btn')[0];
            var dropdownBtn2 = angular.element('.drop-btn')[1];
            var convobarElem = angular.element("#convobar");
            var convobarClass = angular.element('.meevo-logo-container')[0];

            scope.resetNav = (): void => {
                scope.currentLocation = this.identityService.current().locationName;
                var total = 0;
                var navbar = angular.element(".contexts");
                var space = navbar.css("width");
                var spacepx = parseInt(space.slice(0, -2));
                spacepx = spacepx > 960 ? spacepx - 165 : spacepx - 164;
                var contextItems = scope.contexts;
                for (var i = 0; i < contextItems.length; i++) {

                    let menuItem = _(this.menuService.menuItems)
                        .chain()
                        .pluck('subMenuItems')
                        .flatten()
                        .findWhere({ stateName: contextItems[i].name })
                        .value();

                    if(contextItems[i].name === 'reports') {
                        let parentMunu = _(this.menuService.menuItems).findWhere({ stateName: contextItems[i].name });
                        contextItems[i].securityKey = (Model.Guard.isNothing(parentMunu) || Model.Guard.isNothing(parentMunu.securityKey))? null : parentMunu.securityKey;
                    } else {
                        contextItems[i].securityKey = (Model.Guard.isNothing(menuItem) || Model.Guard.isNothing(menuItem.securityKey))? null : menuItem.securityKey;
                    }


                    var temp = total + (8 * contextItems[i].title.length > 118 ? 8 * contextItems[i].title.length : 118) + 35 + i;
                    if (temp + 25 > spacepx) {
                        contextItems[i].navPresence = false;
                    } else {
                        contextItems[i].navPresence = true;
                        total = temp;
                    };
                }

                // Detect clicking on "..." button to open dropdown of additional tabs/sections
                angular.element("body").on("click", function (event) {
                    var pendo = this.window["pendo"];
                    var isPendoShown = pendo ? pendo.BuildingBlocks && pendo.BuildingBlocks.BuildingBlockResourceCenter.getResourceCenter().isShown() : false;
                    if (dropdownBtn1 === angular.element(event.target)[0] || dropdownBtn2 === angular.element(event.target)[0] || angular.element(event.target)[0].classList.contains("meevo-dropdown") || angular.element(event.target)[0].classList.contains("convobar-input")) {
                        scope.displayDropdown = true;
                    } else {
                        scope.displayDropdown = false || isPendoShown;
                    }
                }.bind(this));

                // Close menu if hitting enter in convobar
                //angular.element(".convobar-input").on("keydown", (event: JQueryEventObject) => {
                //    if (event.keyCode == 13) {
                //        scope.displayDropdown = false;
                //    }
                //});
                this.rootScope.displayDropdownFunction = function(){
                    var pendo = this.window["pendo"];
                    var isPendoShown = pendo ? pendo.BuildingBlocks && pendo.BuildingBlocks.BuildingBlockResourceCenter.getResourceCenter().isShown() : false;
                    scope.displayDropdown = false || isPendoShown;
                }.bind(this);

                //if (!scope.offClickBound) {
                //if (dropdownBtn1 != angular.element(event.target)[0] && angular.element(dropdownBtn1).find(event.target).length == 0
                //    && dropdownBtn2 != angular.element(event.target)[0] && angular.element(dropdownBtn2).find(event.target).length == 0
                //    && convobarElem.find(event.target).length == 0 && angular.element(convobarClass).find(event.target).length != 0) {
                //    scope.$apply(function () {
                //        scope.displayDropdown = false;
                //    });
                //}
                //  if (convobarElem.find(event.target).length) {
                //      scope.displayDropdown = true;
                //      scope.offClickBound = false
                //  }
                //  else {
                //      scope.$apply(function () {
                //          //scope.offClickBound = true;
                //          //scope.displayDropdown = false;
                //      })
                //  }
                //}
            };
            scope.closeUserMenu = () => {
                scope.displayUserMenu = false;
            }

            scope.sessionLockout = () => {
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.SESSION_TIMEOUT_HANDLER, Meevo.Model.SessionState.Lockout, 'MeevoNavbar');
            }

            scope.logout = () => {
                this.dataService.logout().then((response: any) => {
                    let url = this.identityService.current().sessionTimeoutRedirectUrl;
                    this.identityService.setIdentity(null);
                    this.window.location.href = url;
                });
            }

            scope.receiptPrinter = localStorage.getItem("receiptPrinter");

            scope.isSingleLocation = this.identityService.current().isSingleLocation;

            scope.changePassword = () => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/components/changePassword/changePassword.html",
                    locals: {
                        model: null,
                        userId: this.identityService.current().userId,
                        userName: this.identityService.current().userAuthName,
                        requireChangePassword: null
                    },
                    controller: "meevo.changePassword.ChangePasswordController",
                    controllerAs: "changePassword",
                    bindToController: true
                }

                scope.receiptPrinterChanged = () => {
                    localStorage.setItem("receiptPrinter", scope.receiptPrinter);
                }

                this.modalService.showCustom(options).then((result) => {

                });

            }

            scope.selectToTab = (contextItem): void => {

                //When an item with navPresence=false is selected we will move it to the 2nd position of the array and then call resetNav to resize
                var from = scope.contexts.indexOf(contextItem);
                scope.contexts.splice(1, 0, scope.contexts.splice(from, 1)[0]);
            }

            angular.element(this.window).on('resize', function () {
                scope.$apply(function () {
                    scope.resetNav();
                });
            });

            scope.$watchCollection('contexts', (contexts, oldContexts) => {
                if (contexts.length > 0) {
                    setTimeout(() => scope.resetNav());
                    this.window.setTimeout(() => { this.rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_SECURITY_KEYS) })
                }
            });

            scope.activeClass = (contextItem): boolean => {
                if (contextItem.status == 'active' || contextItem.status == 'entered') {
            
                    return true;
                }
                return false;
            }
            scope.testInit = () => {
                console.log("initalized please")
                //const context2: IContext = this.state.get('home') as any;
                
            }
            scope.testInit();

            scope.activeStyle = (contextItem): boolean => {
                if (contextItem.status == 'active' || contextItem.status == 'entered') {
                    return true;
                }
                return false;
            }

            scope.tileSize = (contentItem) => {
                let titleLength = this.$translate.instant(contentItem.title).length
                if (scope.isHasPulse([contentItem]) && titleLength * 8 > 118 ) {
                    return 160 + 'px'
                }
                if (titleLength * 8 > 140) {
                    return (8 * titleLength) + 'px';
                } else if (titleLength * 8 > 118) {
                    return 140 + 'px';
                }
                else {
                    return 118 + 'px';
                }
            }

            scope.securityKeys = Meevo.Components.Common.SecurityKeys;

            scope.viewProviderProfile = () => {
                let endpoint: string = this.appSettings.ROUTE_NAMES.profileSettings;
                // Build params for editing promo
                let stateParams = {
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Editing,
                    id: this.identityService.current().userId
                };
                this.rootScope.$broadcast("gotoState",
                    {
                        stateName: endpoint,
                        stateParams: stateParams
                    });
            }

            scope.goToAlertsLog = ($event) => {
                $event.stopPropagation(); // in order to block event viewProviderProfile()
                scope.displayUserMenu = false;
                // todo: dev
                this.rootScope.$broadcast('gotoState', {
                    stateName: this.appSettings.ROUTE_NAMES.alertsLog,
                    stateParams: {
                        showNewAlerts: scope.alertsCount > 0
                    }
                });
            }

            scope.$watch('displayUserMenu', (newValue: boolean, oldValue: boolean) => {
                if (newValue && this.securityService.hasSecurity(scope.securityKeys.MANAGEMENT_ALERTSLOG + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                    scope.getAlertsCount();
                }
            });

            scope.getAlertsCount = () => {
                this.alertsLogService.updateAlertsCount();
            }

            var liveChatSupportUrlWindow;
            scope.startLiveChat = () => {
                var request = {
                    userName: this.identityService.current().userAuthName
                };
                let userId = this.identityService.current().userId;
                let uri = `/${this.appSettings.API_ROOT}/ProfileSettings/${userId}/LiveChatSupport`;

                this.dataService.customMethodData(uri, 'GET', request).then((result) => {
                    if (!result.data.isLiveChatSupportEnabled) {
                        if (this.identityService.current().isSingleLocation)
                            this.modalService.alert("Live Chat support must be enabled in Business Information > Preferences.");
                        else
                            this.modalService.alert("Live Chat support must be enabled by Central Office in Business Information > Preferences.");
                        return;
                    }
                    let liveChatSupportUrl = result.data.liveChatSupportUrl;

                    if (liveChatSupportUrlWindow && !liveChatSupportUrlWindow.closed && liveChatSupportUrlWindow.location) {
                        liveChatSupportUrlWindow.location.href = liveChatSupportUrl;
                    } else {
                        liveChatSupportUrlWindow = open(liveChatSupportUrl, "LiveChatSupport", "location=1,status=1,width=460,height=510,resizable=0");
                    }

                    liveChatSupportUrlWindow.focus();

                    /***  TODO: Cross Window Communication to keep session alive                    **/

                    if (!liveChatSupportUrlWindow || liveChatSupportUrlWindow.closed || typeof liveChatSupportUrlWindow.closed == 'undefined') {
                        //  WHEN POPUP BLOCKED
                        //this.modalService.alert('Unable to open live chat support. Browser Pop-ups are blocked.');
                    }
                })
            }

            scope.submitHelpdeskTicket = () => {
                var request = {
                    userName: this.identityService.current().userAuthName
                };
                let userId = this.identityService.current().userId;
                let uri = `/${this.appSettings.API_ROOT}/ProfileSettings/${userId}/HelpdeskTicket`;
                this.dataService.customMethodData(uri, 'GET', request).then((result) => {
                    let helpdeskTicketURI = result.data;
                    let supportTicketTab = this.window.open(helpdeskTicketURI, '_blank');
                    if (!supportTicketTab || supportTicketTab.closed || typeof supportTicketTab.closed == 'undefined') {
                        //  WHEN POPUP BLOCKED
                        //this.modalService.alert('Cannot naviagte to SalesForce support site. Browser Pop-ups are blocked.');
                        console.log('Cannot open SalesForce support ticket');
                    }
                })

            }

            scope.startSupportSession = () => {
                let screenConnectBase = this.identityService.current().systemSettings.screenConnectBase;
                scope.sessionCode = scope.sessionCode ? scope.sessionCode : '';
                let screenConnectURI = screenConnectBase + scope.sessionCode

                let supportTicketTab = Model.Guard.isSomething(screenConnectBase) ? this.window.open(screenConnectURI, '_blank') : null;

                scope.sessionCode = null;
            }

            scope.isHasPulse = (contexts) => {
                if (!(contexts && contexts.length)) return false;
                return contexts.some(context => context.params && context.params.isHasPulse === true);
            }

            this.rootScope.$on(Components.Common.Messages.UPDATE_LOCATION_NAME, (event, args) => {
                if (!args || !args.locationName || args.locationName === scope.currentLocation) {
                    scope.asImpersonateLocationName = undefined;
                    return;
                }

                scope.asImpersonateLocationName = args.locationName;
                
            });
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($window, identityService, dataService, modalService,
                printService: Meevo.Components.Common.IPrintService,
                appSettings: Meevo.Components.Common.IAppSettings,
                rootScope: ng.IRootScopeService,
                securityService: Meevo.Components.Common.ISecurityService,
                menuService: Meevo.MenuService,
                alertsLogService: Meevo.Plugins.AlertsLog.IAlertsLogService, $translate) => {
                return new MeevoNavbar($window, identityService, dataService, modalService, printService, appSettings, rootScope, securityService, menuService, alertsLogService, $translate);
            };

            directive.$inject = ["$window", "meevo.components.common.IdentityService", "meevo.components.common.DataService",
                "meevo.components.modal.ModalService", "meevo.components.common.PrintService",
                "meevo.AppSettings", "$rootScope", "meevo.components.common.SecurityService",
                "meevo.menuService", 'meevo.plugins.alertsLog.AlertsLogService', "$translate"];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoNavbar', MeevoNavbar.factory());

}
